import React from "react";
import {Timeline} from "antd";
import '../../styles/features/ChangeLog/ChangeLong.css'
const ActivityItem = ({changeLog}) => {
//need to change that if teh ngjarje is in proccesing ,do the done icon
  return (
    <Timeline.Item style={{color:"green"}} className="TimelineItem">
      
      

    </Timeline.Item>
  );
};

export default ActivityItem;
